import {useAlert} from '@contexts/hooks/useAlert.ts';
import {_RecursosEndpoints} from '@localization/siteMap/endpoints/_RecursosEndpoints.ts';
import {DefaultEventProps, DefaultPageProps} from '@models/DefaultProps.ts';
import {IRecurso} from '@models/recurso/IRecurso.ts';
import {IRecursoParam} from '@models/recurso/IRecursoParam.ts';
import {SaveOutlined} from '@mui/icons-material';
import {Button, Grid, Typography, Divider} from '@mui/material';
import {DefaultContainer} from '@shared/DefaultContainer.tsx';
import React, {useEffect, useMemo, useState} from 'react';
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {useRecurso} from "@components/recurso/hooks/useRecurso.ts";
import {InputEntry} from "@components/shared/FormEntries/InputEntry.tsx";
import {IRecursoParamDto} from "@components/recurso/models/dto/IRecursoParamDto.ts";
import {decodeTipoPrimitivo} from "@models/solicitacoes/dto.ts";

export interface RecursoParametrosPageProps extends DefaultPageProps {
	preset: {
		recurso: IRecurso | number
	}
}

export const RecursoParametrosPage: React.FC<RecursoParametrosPageProps & Pick<DefaultEventProps<IRecursoParamDto[]>, 'onUpdate'>> = (props) => {
	const {Get} = useApi();
	const {createAlertFromResponse} = useAlert();
	const {onUpdate} = props;
	const {useRecursoValue, updateParametros} = useRecurso()
	const [recurso] = useRecursoValue(props.preset.recurso);

	const [parametros, setParametros] = useState<IRecursoParam[]>([]);
	const [pagination, setPagination] = useState<IPagination>({page: 0, pageSize: 10})
	const [refreshRequested, setRefreshRequested] = useState(false);
	const [entries, setEntries] = useState<IRecursoParamDto[]>([]);

	useEffect(() => {
		if (recurso == null) return;

		if (pagination.page == 0) {
			setPagination({...pagination, page: 1});
			return;
		}

		Get(_RecursosEndpoints.GetRecursoParams({recursoId: recurso?.id}, pagination), refreshRequested).then(x => {
			if (x.hasData) {
				setParametros(x.items);
				setRefreshRequested(false)
			} else {
				createAlertFromResponse(x);
			}
		});

	}, [pagination.page, recurso, refreshRequested]);

	useEffect(() => {
		setEntries(parametros.map(x => {
			const entry = x.entries[0]
			return ({
				parametro: x.id,
				tipoPrimitivo: x.tipoPrimitivo,
				recursoId: entry?.recursoId ?? recurso?.id,
				valor: entry?.valor
			}) as IRecursoParamDto
		}))
	}, [parametros]);

	useEffect(() => {
		console.log(JSON.stringify(entries))
	}, [entries]);
	const changed = recurso && recurso.parametrosEntries && JSON.stringify(recurso.parametrosEntries) !== JSON.stringify(parametros);

	const entriesTypes = useMemo(() => {
		return entries.map(x => x.tipoPrimitivo).filter((x, i, a) => a.indexOf(x) === i);
	}, [entries]);


	return (
		<DefaultContainer titulo={'Parametros do Recurso'} component={'div'} size={'large'}
		                  hideHeader={props.hideHeader}>
			<Grid container spacing={1.5}>
				<Grid size={12}>
					<Grid container justifyContent={'space-between'}>
						<Button disabled={!changed} variant={'outlined'}
						        onClick={() => {
							        if (entries && entries.length > 0 && recurso != null) {
								        updateParametros({idRecurso: recurso.id, parametros: [...entries]}).then(x => {
										        createAlertFromResponse(x);
										        if (x.status == 'Success') {
											        if (onUpdate)
												        onUpdate(x.items);
											        setRefreshRequested(true);
										        }
									        },
								        );

							        }
						        }}
						        endIcon={<SaveOutlined/>}>Salvar</Button>
					</Grid>
				</Grid>
				<Grid container size={12}>
					{entriesTypes.map((x) => (
						<Grid size={12} key={x} container>
							<Grid size={12}>
								<Typography textAlign={'center'} variant={'subtitle1'}>
									{decodeTipoPrimitivo(x)}
								</Typography>
								<Divider/>
							</Grid>
							<Grid container size={12}>
								{parametros.filter(p => p.tipoPrimitivo == x).map(x => (
									<Grid key={x.id} size={{xs: 12, sm: 6}}>
										<InputEntry primitiveType={x.tipoPrimitivo}
										            label={x.nome}
										            value={entries.find(e => e.parametro == x.id)?.valor ?? ''}
										            onChange={(v) => {
											            const updatedEntries = entries.map(e => {
												            if (e.parametro == x.id) {
													            return {...e, valor: v?.toString()};
												            }
												            return e;
											            }) as IRecursoParamDto[];
											            setEntries(updatedEntries);
										            }}
										            slotProps={{tooltip: x.descricao}}/>
									</Grid>))}
							</Grid>
						</Grid>
					))}
				</Grid>
			</Grid>
		</DefaultContainer>
	)
}